////////////////////////////////////////////////////////////
//     							                                      //
//  Program: CostPayableBy.jsx                           //
//  Application: Financial                                   //
//  Option: to view CostPayableBy data                  //
//  Developer: Ashish Kumar                               //
//  Date: 2022-01-06                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import {
  // Button,
  Table,
  Modal,
  Form,
} from "react-bootstrap";
import Alerts from "../common/Alerts";
// import deleteicon from "../../assets/images/delete.svg";
import SimpleReactValidator from "simple-react-validator";
import modaldeleteicon from "./../../assets/images/delete.svg";
import CostPayableByService from "../../services/CostPayableByService";
// import pluswIcon from './../../assets/images/plus.svg';
import { Container } from "react-bootstrap";
import MasterSidebar from "../common/MasterSidebar";
import NoData from "../common/NoData";

export class CostPayableBy extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      open: global.showOpen,
      eventKey: "",
      input: {},
      errors: {},
      toggleSwitchDark2: true,
      status_id: true,
      slug: "",
      //for CostPayableBy
      addCostPayableByModal: false,
      editCostPayableByModal: false,
      deleteCostPayableByModal: false,
      costPayableByList: [],
      costPayableByListTotal: 0,
      cost_payable_by_name: "",
      sort_order: "",
    };
    this.changeHandler = this.changeHandler.bind(this);

    /* for Cost Payable By */
    this.openAddCostPayableByModal = this.openAddCostPayableByModal.bind(this);
    this.openEditCostPayableByModal =
      this.openEditCostPayableByModal.bind(this);
    this.openDeleteCostPayableByModal =
      this.openDeleteCostPayableByModal.bind(this);
    this.saveCostPayableBy = this.saveCostPayableBy.bind(this);
    this.getCostPayableByDetails = this.getCostPayableByDetails.bind(this);
    this.updateCostPayableBy = this.updateCostPayableBy.bind(this);
    this.deleteCostPayableBy = this.deleteCostPayableBy.bind(this);
  }

  componentDidMount() {
    this.getCostPayableByData();
  }

  /* To get Cost Payable by list data */
  async getCostPayableByData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var costPayableByList = [];
    var costPayableByListTotal = 0;

    let res = await CostPayableByService.getCostPayableBy(
      queryString ? "&" + queryString : ""
    );

    if (global.successStatus.includes(res.status)) {
      costPayableByList = res.data.data ? res.data.data : [];
      costPayableByListTotal = costPayableByList ? costPayableByList.length : 0;
    }
    this.setState({
      costPayableByList: costPayableByList,
      costPayableByListTotal: costPayableByListTotal,
    });
    this.setState({ showSpinner: false, loading: false });
  }

  /* To save Cost Payable by data */
  saveCostPayableBy = async (e) => {
    e.preventDefault();
    if (
      this.customValidate() &&
      !this.validator.errorMessages.cost_payable_by_name &&
      !this.validator.errorMessages.sort_order
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        cost_payable_by_name: this.state.cost_payable_by_name,
        sort_order: this.state.sort_order,
        status_id: this.state.status_id === true ? 1 : 2,
      };

      let res = await CostPayableByService.createCostPayableBy(inputData);
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        this.closeAddCostPayableByModal();
        this.setState({
          cost_payable_by_name: "",
          status_id: true,
          sort_order: "",
        });
        this.getCostPayableByData();
      } else {
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        // this.setState({
        //   showAlertModal: true,
        //   alertModalType: "error",
        //   alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        //   alertModalMessage: res.data.message ? res.data.message : "Error!",
        // });
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };

  /* to get cost payable by details data  */
  async getCostPayableByDetails(slug) {
    this.setState({ showSpinner: true, isSubmit: true });
    if (slug) {
      var resData = {};
      let res = await CostPayableByService.getCostPayableByBySlug(slug);
      if (global.successStatus.includes(res.status)) {
        resData = res.data ? res.data : {};
        resData.cost_payable_by_name = res.data.cost_payable_by_name
          ? res.data.cost_payable_by_name
          : "";
        resData.sort_order = res.data.sort_order ? res.data.sort_order : "";
        resData.status_id = res.data.status_id === 1 ? true : false;
      }
      this.setState(resData);
    }
    this.setState({ showSpinner: false, isSubmit: false });
  }

  /* to update cost payable by data */
  updateCostPayableBy = async (e) => {
    e.preventDefault();
    if (
      this.customValidate() &&
      !this.validator.errorMessages.cost_payable_by_name &&
      !this.validator.errorMessages.sort_order
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        cost_payable_by_name: this.state.cost_payable_by_name,
        sort_order: this.state.sort_order,
        status_id: this.state.status_id === true ? 1 : 2,
      };

      let res = await CostPayableByService.updateCostPayableBy(
        this.state.slug,
        inputData
      );
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        this.closeEditCostPayableByModal();
        this.setState({
          cost_payable_by_name: "",
          status_id: true,
          sort_order: "",
        });
        this.getCostPayableByData();
      } else {
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        // this.setState({
        //   showAlertModal: true,
        //   alertModalType: "error",
        //   alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        //   alertModalMessage: res.data.message ? res.data.message : "Error!",
        // });
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };

  /* to delete cost payable by data */
  async deleteCostPayableBy(slug) {
    this.setState({ showSpinner: true });
    let res = await CostPayableByService.deleteCostPayableBy(slug);
    if (global.successStatus.includes(res.status)) {
      this.closeDeleteCostPayableByModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });

      this.getCostPayableByData();
    } else {
      this.closeDeleteCostPayableByModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.errorMessage
          ? res.data.errorMessage
          : res.data.message,
      });
    }
    this.setState({ showSpinner: false });
    this.closeDeleteCostPayableByModal();
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }

  changeHandler = (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    value = event.target.type === "radio" ? parseInt(value) : value;
    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });
  };

  customValidate() {
    let isValid = true;
    return isValid;
  }

  closeModal() {
    this.setState({ showAlertModal: false });
  }

  /* cost payable by Modals */
  openAddCostPayableByModal() {
    this.setState({ addCostPayableByModal: true });
  }

  closeAddCostPayableByModal() {
    this.setState({ addCostPayableByModal: false });
    this.setState({
      cost_payable_by_name: "",
      sort_order: "",
      errors: "",
      status_id: true,
    });
    this.validator.hideMessages();
  }

  openEditCostPayableByModal(slug) {
    this.getCostPayableByDetails(slug);
    this.setState({ editCostPayableByModal: true });
    this.setState({ slug: slug });
  }

  closeEditCostPayableByModal() {
    this.setState({ editCostPayableByModal: false });
    this.setState({
      slug: "",
      cost_payable_by_name: "",
      sort_order: "",
      status_id: true,
      errors: "",
    });
    this.validator.hideMessages();
  }

  openDeleteCostPayableByModal(slug) {
    this.setState({ deleteCostPayableByModal: true });
    this.setState({ slug: slug });
  }

  closeDeleteCostPayableByModal() {
    this.setState({ deleteCostPayableByModal: false });
    this.setState({ slug: "" });
  }

  setOpen(open, e) {
    this.setState({ open: open });
    this.setState({ eventKey: e.target.id });
    const scrollId = document.getElementById(e.target.id);
    scrollId.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  }

  getTitle() {
    return "Cost Payable By";
  }

  render() {
    return (
      <>
        {/* cost payable by card */}
        {/* <Card>
          <Card.Header>
            <Accordion.Toggle
              as={Button}
              variant="link"
              eventKey="23"
              id="23"
              onClick={(e) => this.setOpen(!this.state.open, e)}
            >
              Cost Payable By
              <i className="mdi mdi-view-headline"> </i>
              {this.state.open && this.state.eventKey === "23" ? (
                <i className="fas fa-chevron-down"></i>
              ) : (
                <i className="fas fa-chevron-up"></i>
              )}
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="23">
            <Card.Body>
              <div className="row d-flex justify-content-end mg-r-0 mg-b-15">
               {global.userPermissions.checkPermission(
                              "master-data-delete"
                            ) && (
                <Button
                  variant="outline-dark btn-block btn-with-icon"
                  onClick={this.openAddCostPayableByModal}
                >
                  <img src={pluswIcon} /> Add
                </Button>
                )}
              </div>
              <div className="col-md-12 pl-0 pr-0">
                <Alerts
                  show={this.state.showAlertModal}
                  type={this.state.alertModalType}
                  title={this.state.alertModalTitle}
                  message={this.state.alertModalMessage}
                />
              </div>
              <div className="table-responsive">
                <Table hover className="mg-b-0">
                  <thead>
                    <tr>
                      <th className="w-50">Cost Payable By Name</th>
                      <th className="w-25">Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.costPayableByListTotal > 0 ? (
                      this.state.costPayableByList.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td className="hand-cursor" onClick={() =>
                              {global.userPermissions.checkPermission(
                              "master-data-update"
                            ) && ( this.openEditCostPayableByModal(item.slug) )}
                            } >{item.cost_payable_by_name}</td>
                            <td>
                              {item.status_id === 1 ? (
                                <b className="active"></b>
                              ) : (
                                <b></b>
                              )}
                            </td>
                             {global.userPermissions.checkPermission(
                              "master-data-delete"
                            ) && (
                            <td>
                              <div className="btn-icon-list d-block text-center">
                                <img
                                  src={deleteicon}
                                  alt="Delete"
                                  onClick={() =>
                                    this.openDeleteCostPayableByModal(item.slug)
                                  }
                                  className="hand-cursor"
                                />
                              </div>
                            </td>)}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" align="center">
                          No rows found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card> */}

        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0">
                <div className="col-md-2 left">
                  <div className="child-menu-section">
                    <aside>
                      <MasterSidebar />
                    </aside>
                  </div>
                </div>
                <div className="col-md-10 right settingsidebarNav">
                  <div className="col-md-12 mg-t-10 mg-b-10 pd-t-10 pd-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                      <h3>{this.getTitle()}</h3>
                      {/* <div className="d-flex justify-content-end pd-l-0 pd-r-0 mg-b-0">
            <Button
                variant="outline-dark btn-block btn-with-icon"
                onClick={this.openAddCostPayableByModal}
              >
                <img src={pluswIcon} /> Add
              </Button>
            </div> */}
                    </div>
                  </div>
                  <div className="master">
                    <div className="table-responsive">
                      {/* <div className="row d-flex justify-content-end mg-r-0 mg-b-15">
              <Button
                variant="outline-dark btn-block btn-with-icon"
                onClick={this.openAddCostPayableByModal}
              >
                <img src={pluswIcon} /> Add
              </Button>
            </div> */}
                      <div className="col-md-12 pl-0 pr-0">
                        <Alerts
                          show={this.state.showAlertModal}
                          type={this.state.alertModalType}
                          title={this.state.alertModalTitle}
                          message={this.state.alertModalMessage}
                        />
                      </div>
                      {this.state.costPayableByListTotal > 0 ? (
                        <Table hover className="mg-b-0">
                          <thead>
                            <tr>
                              <th className="w-50">Cost Payable By Name</th>
                              <th className="w-25">Status</th>
                              {/* <th className="text-center">Action</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.costPayableByListTotal > 0 ? (
                              this.state.costPayableByList.map((item, i) => {
                                return (
                                  <tr key={i}>
                                    {/* <td className="hand-cursor" onClick={() =>
                          this.openEditCostPayableByModal(item.slug)
                        } >{item.cost_payable_by_name}</td> */}
                                    <td>
                                      {item.cost_payable_by_name
                                        ? item.cost_payable_by_name
                                        : ""}
                                    </td>
                                    <td>
                                      {item.status_id === 1 ? (
                                        <b className="active"></b>
                                      ) : (
                                        <b></b>
                                      )}
                                    </td>
                                    {/* <td>
                          <div className="btn-icon-list d-block text-center">
                            <img
                              src={deleteicon}
                              alt="Delete"
                              onClick={() =>
                                this.openDeleteCostPayableByModal(item.slug)
                              }
                              className="hand-cursor"
                            />
                          </div>
                        </td> */}
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="9" align="center">
                                  There are no cost payable by added in the
                                  system. You may add them by clicking Add
                                  button.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      ) : (
                        <NoData
                          msg={global.commonMessages.checkMessage(
                            "COSTPAYABLEBY"
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        {/* add cost Payable By popup modal */}
        <Modal
          show={this.state.addCostPayableByModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeAddCostPayableByModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeAddCostPayableByModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Add Cost Payable By</h3>
            <label>Cost Payable By Name</label>
            <Form.Control
              onChange={this.changeHandler}
              name="cost_payable_by_name"
              value={this.state.cost_payable_by_name}
              className="form-control max_width_100"
              id="inlineFormInput"
              type="text"
              maxLength="50"
              autoComplete="off"
              //placeholder="Cost Payable By Name"
            />
            {this.state.errors.cost_payable_by_name ? (
              <div className="text-danger">
                {this.state.errors.cost_payable_by_name}
              </div>
            ) : (
              this.validator.message(
                "cost_payable_by_name",
                this.state.cost_payable_by_name,
                "required",
                { className: "text-danger" }
              )
            )}

            {/* <InputGroup className="mt-3">
              <label>Sort Order</label>
              <Form.Control
                onChange={this.changeHandler}
                name="sort_order"
                value={this.state.sort_order}
                onKeyPress={global.onKeyPressEvent.numberValidation}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                placeholder="Sort Order"
              />
            </InputGroup>
            {this.state.errors.sort_order ? (
              <div className="text-danger">{this.state.errors.sort_order}</div>
            ) : (
              this.validator.message(
                "sort_order",
                this.state.sort_order,
                "numeric|min:0,num",
                { className: "text-danger" }
              )
            )} */}

            <div className="d-flex align-items-center justify-content-end mt-3">
              <b className={this.state.status_id ? "active" : "inactive"}>
                {this.state.status_id ? "active" : "inactive"}
              </b>
              <div
                className={this.state.status_id ? "az-toggle on" : "az-toggle"}
                onClick={() =>
                  this.setState({ status_id: !this.state.status_id })
                }
              >
                <span></span>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-3 row">
              <button
                type="button"
                className="mx-auto m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeAddCostPayableByModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="mx-auto m-0 btn btn btn-success btn-block"
                onClick={this.saveCostPayableBy}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* edit Cost Payable By popup modal */}
        <Modal
          show={this.state.editCostPayableByModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeEditCostPayableByModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeEditCostPayableByModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Update Cost Payable By</h3>
            <label>Cost Payable By Name</label>
            <Form.Control
              onChange={this.changeHandler}
              name="cost_payable_by_name"
              value={this.state.cost_payable_by_name}
              className="form-control max_width_100"
              id="inlineFormInput"
              type="text"
              maxLength="50"
              autoComplete="off"
              //placeholder="Cost Payable By Name"
            />
            {this.state.errors.cost_payable_by_name ? (
              <div className="text-danger">
                {this.state.errors.cost_payable_by_name}
              </div>
            ) : (
              this.validator.message(
                "cost_payable_by_name",
                this.state.cost_payable_by_name,
                "required",
                { className: "text-danger" }
              )
            )}

            {/* <InputGroup className="mt-3">
              <label>Sort Order</label>
              <Form.Control
                onChange={this.changeHandler}
                name="sort_order"
                value={this.state.sort_order}
                onKeyPress={global.onKeyPressEvent.numberValidation}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                placeholder="Sort Order"
              />
            </InputGroup>
            {this.state.errors.sort_order ? (
              <div className="text-danger">{this.state.errors.sort_order}</div>
            ) : (
              this.validator.message(
                "sort_order",
                this.state.sort_order,
                "numeric|min:0,num",
                { className: "text-danger" }
              )
            )} */}

            <div className="d-flex align-items-center justify-content-end mt-3">
              <b className={this.state.status_id ? "active" : "inactive"}>
                {this.state.status_id ? "active" : "inactive"}
              </b>
              <div
                className={this.state.status_id ? "az-toggle on" : "az-toggle"}
                onClick={() =>
                  this.setState({ status_id: !this.state.status_id })
                }
              >
                <span></span>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-3">
              <button
                type="button"
                className="mx-auto m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeEditCostPayableByModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="mx-auto m-0 btn btn btn-success btn-block"
                onClick={this.updateCostPayableBy}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* delete Cost Payable By popup modal */}
        <Modal
          show={this.state.deleteCostPayableByModal}
          // onHide={() => {
          //   if (
          //     window.confirm("Are you sure to exit the pop up without delete?")
          //   )
          //     this.closeDeleteCostPayableByModal();
          // }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <span
                className="welcomeClose"
                onClick={() => this.closeDeleteCostPayableByModal()}
              >
                {global.closee}
              </span>
              <img src={modaldeleteicon} alt="modal-delete-icon" />
              <h3>Delete the Option?</h3>
              <p>
                Do you really want to delete this option? This process cannot be
                undone.
              </p>
              <div className="d-flex justify-content-center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeDeleteCostPayableByModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.deleteCostPayableBy(this.state.slug)}
                  disabled={this.state.isSubmit ? true : false}
                >
                  {this.state.isSubmit ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default CostPayableBy;
